/*jshint globalstrict: false*/
export default {
    methods: {
        getDiscountCents(size, qty, buyNowDiscounts, customBagDiscounts) {
            var bagDiscounts = customBagDiscounts.filter(r => r.custom_size.imperial_uom === size || r.custom_size.metric_uom === size );
            if (bagDiscounts.length > 0){
                return (bagDiscounts.filter(r=> r.quantity === qty).length > 0 ? (bagDiscounts.filter(r=> r.quantity === qty)[0].discount) * 100 : 0 );
            }else{
                const discounts = size === '5lb' ? buyNowDiscounts['5lb'] : buyNowDiscounts['12oz'];
                if (!Number.isInteger(discounts[qty])) {
                    console.error('Invalid discount price!', this.order, discounts, size, qty, buyNowDiscounts);
                    return 0;
                }
                return discounts[qty];
            }   
        },
        calculateTotalPriceCents(qty, unitPriceCents, discountCents) {
            if (Number.isInteger(unitPriceCents) && Number.isInteger(qty) && Number.isInteger(discountCents)) {
                return unitPriceCents * qty - discountCents;
            }
            console.error('Cannot calculate the total price!', unitPriceCents, qty, discountCents);
            return null;
        },
        getIncompleteOrder() {
            const order = localStorage.getItem('BuyNowIncompleteOrder');
            localStorage.removeItem('BuyNowIncompleteOrder');
            return order && JSON.parse(order);
        }
    }
};
